import { render, staticRenderFns } from "./DashFees.vue?vue&type=template&id=e317baf4&scoped=true&"
import script from "./DashFees.vue?vue&type=script&lang=js&"
export * from "./DashFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e317baf4",
  null
  
)

export default component.exports